import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Button, IconButton, Menu, MenuItem, Switch } from "@mui/material";

import { GridColDef } from "@mui/x-data-grid";
import SearchBar from "../../components/SearchBar";
import TableComponent from "../../components/TableComponent";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import { isValidInput } from "../../utils/validations";
import { errorToast, successToast } from "../../helpers";
import { UPDATE_TYPES } from "../../utils/enums";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody, PaymentPlanType } from "../../types/General";
import {
  useGetAllPaymentPlanMutation,
  useLazyDeletePaymentPlanQuery,
  useUpdatePaymentPlanMutation,
} from "../../service/paymentPlan";
import { PriceFormatter } from "../../utils/commoFunctions";

const PaymentPlans = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");

  const [selectedId, setSelectedId] = useState<number | null>(null);

  const [open, setOpen] = useState(false);

  const [getPaymentPlans] = useGetAllPaymentPlanMutation();
  const [deletePaymentPlan] = useLazyDeletePaymentPlanQuery();
  const [changeStatus] = useUpdatePaymentPlanMutation();

  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<PaymentPlanType[]>([]);
  const [page, setPage] = useState<number>(1);
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowId: number
  ) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
    setSelectedId(null);
  };

  // const getMaxPaymentParts = (rows: any[] = []) => {
  //   return Math.max(...rows?.map((row) => row?.payment_parts?.length));
  // };

  const getMaxPaymentParts = (rows?: any[]) => {
    if (!Array.isArray(rows)) return 0;
    return Math.max(...rows.map((row) => row?.payment_parts?.length || 0));
  };

  const ordinalNumbers = [
    "First",
    "Second",
    "Third",
    "Fourth",
    "Fifth",
    "Sixth",
    "Seventh",
    "Eighth",
    "Ninth",
    "Tenth",
  ];

  const getOrdinalLabel = (index: number) => {
    return ordinalNumbers[index] || `${index + 1}th`;
  };

  const baseColumns: GridColDef<any>[] = [
    {
      flex: 1,
      minWidth: 200,
      field: "planName",
      headerName: "Plan Name",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => (
        <div className="user_block">
          <p>{row?.plan_name || ""}</p>
        </div>
      ),
    },
    // {
    //   flex: 1,
    //   minWidth: 150,
    //   field: "visaType",
    //   headerName: "Visa Type",
    //   editable: false,
    //   sortable: false,
    //   renderCell: ({ row }) => (
    //     <div className="user_block">
    //       <p>{row?.visa_type_name || ""}</p>
    //     </div>
    //   ),
    // },
    {
      flex: 1,
      minWidth: 150,
      field: "price",
      headerName: "Total Price",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => (
        <div className="user_block">
          <p>{PriceFormatter(row?.total_price?.toString()) || ""}</p>
        </div>
      ),
    },
  ];

  const generatePaymentColumns = (
    maxParts: number
  ): GridColDef<PaymentPlanType>[] => {
    return Array.from({ length: maxParts }, (_, index) => [
      {
        flex: 1,
        minWidth: 150,
        field: `payment_${index + 1}`,
        headerName: `${getOrdinalLabel(index)} Payment`,
        editable: false,
        sortable: false,
        renderCell: ({ row }: { row: PaymentPlanType }) => {
          const part = row?.payment_parts[index];
          return (
            <div className="user_block">
              <p>{part ? PriceFormatter(part?.amount?.toString()) : "-"}</p>
            </div>
          );
        },
      },
      {
        flex: 1,
        minWidth: 150,
        field: `commission_${index + 1}`,
        headerName: `${getOrdinalLabel(index)} Payment Commission`,
        editable: false,
        sortable: false,
        renderCell: ({ row }: { row: PaymentPlanType }) => {
          const part = row?.payment_parts[index];
          return (
            <div className="user_block">
              <p>
                {part?.commission_for_agent
                  ? PriceFormatter(part?.commission_for_agent?.toString())
                  : "-"}
              </p>
            </div>
          );
        },
      },
    ]).flat();
  };

  const maxPaymentParts = getMaxPaymentParts(rows);

  const columns: GridColDef<(typeof rows)[number]>[] = [
    ...baseColumns,
    ...generatePaymentColumns(maxPaymentParts),
    {
      flex: 1,
      minWidth: 150,
      field: "disable",
      headerName: "Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={row?.is_active}
            onChange={() =>
              handleStatusUpdate(row?.id, !row?.is_active, UPDATE_TYPES.BLOCK)
            }
          />
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={(event) => handleClick1(event, row?.id)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                    borderRadius: "8px",
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => {
                    navigate(`edit/${selectedId}`);
                  }}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setAnchorEl1(null);
                    setOpen(true);
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await deletePaymentPlan({
        id: selectedId,
      }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        successToast("Deleted successfully");
        getAllPaymentPlans();
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const handleStatusUpdate = async (id: number, status: any, type: string) => {
    const body = {
      ...(type === UPDATE_TYPES.BLOCK ? { is_active: status } : {}),
    };

    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await changeStatus({
        body: encryptedBody,
        id: id,
      }).unwrap();
      if (response?.status === 200) {
        const updatedData = rows?.map((item) => {
          if (item?.id === id) {
            return {
              ...item,
              is_active: status,
            };
          }
          return item;
        });
        setRows(updatedData);
        if (status === true) {
          successToast("Status enabled successfully");
        } else {
          successToast("Status disabled successfully");
        }
      } else {
        errorToast("Please try again");
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  const getAllPaymentPlans = async () => {
    setLoading(true);
    try {
      const body = {
        start: page,
        length: 10,
        search: debouncedSearchTerm.trim(),
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await getPaymentPlans(encryptedBody).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setRows(response?.data?.response_object || []);
        setCount(response?.data?.total_records);
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllPaymentPlans();
  }, [debouncedSearchTerm, page]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Payment Plans</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Payments - Payment Plans
        </p>
      </div>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s fdx">
              <Button className="btn btn_blue" onClick={() => navigate("add")}>
                Add Payment Plan
              </Button>
            </div>
          </div>

          <div className="sorting_table">
            <TableComponent
              columns={columns}
              rows={rows}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />
          </div>
        </Box>
        <ConfirmationModal
          text={"Are you sure to delete this payment plan?"}
          openModal={open}
          setOpenModal={setOpen}
          handleSubmit={handleDelete}
        />
      </div>
    </MainContainer>
  );
};

export default PaymentPlans;
